import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";
import { toast } from "sonner";
import { formatApiError } from "../../lib/api";

export default function AdminLogin() {
    const { user, login } = useAuth();
    const [email, setEmail] = useState("admin@istanbuldovmesilme.com");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    if (user && user !== false) return <Navigate to="/admin/leads" replace />;

    const submit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            await login(email, password);
            navigate("/admin/leads");
        } catch (err) {
            toast.error(formatApiError(err.response?.data?.detail) || err.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen bg-[#050505] flex items-center justify-center px-6">
            <form
                onSubmit={submit}
                className="w-full max-w-md bg-[#0E0E0E] border border-white/5 rounded-2xl p-8 space-y-6"
                data-testid="admin-login-form"
            >
                <div>
                    <p className="text-xs uppercase tracking-[0.3em] text-cyan-300/80 mb-2">
                        Yönetim Paneli
                    </p>
                    <h1 className="font-display text-2xl text-white">Giriş Yap</h1>
                </div>
                <div className="space-y-2">
                    <Label className="text-zinc-300 text-xs uppercase tracking-wider">E-posta</Label>
                    <Input
                        type="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                        className="bg-[#141414] border-white/10 text-white"
                        data-testid="login-email"
                    />
                </div>
                <div className="space-y-2">
                    <Label className="text-zinc-300 text-xs uppercase tracking-wider">Şifre</Label>
                    <Input
                        type="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                        className="bg-[#141414] border-white/10 text-white"
                        data-testid="login-password"
                    />
                </div>
                <Button
                    type="submit"
                    disabled={loading}
                    className="w-full bg-cyan-400 text-black hover:bg-cyan-300 font-medium py-6"
                    data-testid="login-submit"
                >
                    {loading ? "Giriş yapılıyor..." : "Giriş Yap"}
                </Button>
            </form>
        </div>
    );
}
